import Hero from '../components/home/Hero';
import Stats from '../components/home/Stats';
import ServicesPreview from '../components/home/ServicesPreview';
import Testimonials from '../components/home/Testimonials';
import CTA from '../components/home/CTA';

export default function HomePage({ setActiveTab }) {
  return (
    <div>
      <Hero setActiveTab={setActiveTab} />
      <Stats />
      <ServicesPreview setActiveTab={setActiveTab} />
      <Testimonials />
      <CTA setActiveTab={setActiveTab} />
    </div>
  );
}